// extracted by mini-css-extract-plugin
export var defaultWrapper = "_k5-3";
export var downloadButton = "_k5-4";
export var fileContainer = "_k5-9 _k5-7";
export var fileContainerBase = "_k5-7";
export var fileContainerFixedHeight = "_k5-8 _k5-7";
export var fileInfo = "_k5-5";
export var fileInfoWidthRestricted = "_k5-6";
export var fileType = "_k5-1";
export var fileTypeName = "_k5-2";
export var image = "_k5-0";
export var link = "_k5-b";
export var overflowEllipsis = "_k5-a";